import * as ReactDOM from "react-dom/client";
import {refreshPageDataCache} from "../lib/pageDataCacheRefresh";

// Store roots in a WeakMap to allow proper cleanup
const roots = new WeakMap();

const browserHydrateFunction = () => {
  // Await the cache reload BEFORE render. A fire-and-forget fetch in
  // onClientEntry still lets Gatsby hydrate from the stale page-data.json
  // (OA-267: 2023 Terms over 2026 HTML). Gatsby does not wait on this
  // promise; we simply do not call render until both requests settle.
  return async (element, container) => {
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : "/";
    await refreshPageDataCache(pathname);
    let root = roots.get(container);
    if (!root) {
      root = ReactDOM.createRoot(container);
      roots.set(container, root);
      // Store root reference on container for potential cleanup by Gatsby's head-export-handler
      container._reactRootContainer = root;
    }
    root.render(element);
  };
};

export default browserHydrateFunction;
